<div class="grid-container">
  <div class="grid-toolbar" fxLayout="row">
    <h1 class="mat-h1" fxFlex="80">Templates</h1>
    <div fxFlex="20" class="toolbar-buttons">
      <button mat-raised-button color="accent" (click)="startNew()">
        Add Template
      </button>
    </div>
  </div>
  <div class="" *ngIf="selected">
    <app-template-form
      [template]="selected"
      (completed)="completed($event)"
    ></app-template-form>
  </div>
  <mat-grid-list *ngIf="!selected" cols="1" rowHeight="300px">
    <mat-grid-tile
      *ngFor="let card of cards | async"
      [colspan]="1"
      [rowspan]="1"
    >
      <mat-card class="dashboard-card">
        <mat-card-header>
          <mat-card-title>
            {{ card.name }}
            <button
              mat-icon-button
              class="more-button"
              [matMenuTriggerFor]="menu"
              aria-label="Toggle menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item (click)="edit(card.id)">Edit</button>
              <button mat-menu-item (click)="remove(card.id)">Remove</button>
            </mat-menu>
          </mat-card-title>
          <mat-card-subtitle>
            {{ card.slug }}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="dashboard-card-content">
          <div class="body">
            {{ card.body }}
          </div>
          <div class="url"><strong>URL:</strong> {{ card.url }}</div>
          <div class="updated">
            <strong>Last updated by</strong> {{ card.updated_by }}
            {{ card.last_update | date: "short" }}
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
